import React from 'react';
import type { CMSLinkType } from '@/components/cms-link';
import { Media } from '@/components/media';
import type { Media as MediaType } from '@/payload-types';

export interface RichTextUploadNodeType {
  fields: {
    link?: CMSLinkType;
    enableLink?: boolean;
  };
  value?: MediaType;
  relationTo: string;
}

export interface Props {
  node: RichTextUploadNodeType;
  className?: string;
  isPost?: boolean;
}

export const RichTextUpload: React.FC<Props> = ({
  node,
  className,
  isPost,
}) => {
  const { fields, value } = node;

  const styles: React.CSSProperties = {};

  return (
    <div style={styles} className={className}>
      <Media resource={value} isPostImage={isPost} link={fields?.link} />
    </div>
  );
};

export default RichTextUpload;
